import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'

// Authentication plugin
import AuthPlugin from './plugins/auth'

// Vuelidate
import Vuelidate from 'vuelidate'

// Element UI
import ElementUI from 'element-ui'
import './assets/element-ui.css'
import locale from 'element-ui/lib/locale/lang/en'

// Bootstrap Vue
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import BootstrapVue from 'bootstrap-vue'

// Form validation with Vuex
import VeeValidate from 'vee-validate'

// Font awesome icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { faExclamationTriangle, faMinusCircle, faPlusCircle, faUndo, faInfoCircle, faCog, faChartArea, faFileInvoiceDollar, faClock, faUser, faUserFriends, faStore, faFileExport, faUsers, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Main stylesheet
import './assets/style.scss'

import VueDataTables from 'vue-data-tables'

import VGauge from 'vgauge'

import VueHead from 'vue-head'

Vue.use(VueHead)
Vue.use(VGauge)

Vue.use(VueDataTables)
Vue.use(AuthPlugin)
Vue.use(Vuelidate)
library.add(faExclamationTriangle, faMinusCircle, faPlusCircle, faUndo, faCog, faChartArea, faFileInvoiceDollar, faClock, faUser, faUserFriends, faStore, faFileExport, faUsers, faCircleNotch, faInfoCircle)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(ElementUI, { locale })
Vue.use(BootstrapVue)
const config = {
    fieldsBagName: 'fieldsRenamed'
}
Vue.use(VeeValidate, config)
Vue.config.productionTip = false

Vue.filter('formatVariableName', function (value) {
    let allCaps = ['kpu', 'ctr']
    if (allCaps.includes(value)) {
        return value.toUpperCase()
    } else {
        try {
            let variable = value.replace('_', ' ')
            variable = variable.replace('_', ' ')
            variable = variable.replace('_', ' ')
            variable = variable.replace('_', ' ')
            return variable.charAt(0).toUpperCase() + variable.slice(1)
        } catch (error) {
            return value
        }
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
